let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5xjpu")).then(() => parcelRequire('bbYyR'));